export enum JobStatus {
    Started = 1,
    Pending,
    Processing,
    Completed,
    NotFound,
    Enqueued = 6,
    Deleted = 7,
    Fail = 8,
}

